import CloseIcon from '@mui/icons-material/Close';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import IconButton from '@mui/material/IconButton';
import Modal from '@mui/material/Modal';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

const StyledModal = styled(Modal)`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const ModalContainer = styled(Box)`
  background-color: white;
  border-radius: 12px;
  width: 65vw;
  height: 90vh;
  overflow: hidden;
  position: relative;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  display: flex;
  flex-direction: column;
`;

const CloseDiv = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  padding: 10px;
`;

const IframeWrapper = styled.div`
  flex: 1;
  display: ${({ isLoaded }) => (isLoaded ? 'block' : 'none')}; /* Hide iframe initially */
  overflow-y: auto;
  border-radius: 20px;
  justify-content: center;
  align-items: center;
`;

const LoaderWrapper = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const SignUpPopup = ({ open, onClose }) => {
  const [isLoaded, setIsLoaded] = useState(false); // Track iframe load state

  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://link.iyuga.net/js/form_embed.js';
    script.async = true;
    script.onload = () => console.log('Form embed script loaded');
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);
  let nav = useNavigate();

  const handleClose = () => {
    nav('/login');
  };

  const iframeSrc = `https://link.iyuga.net/widget/form/mRwqwIryVYc9nKbM3Rxr`;

  return (
    <StyledModal open={open} onClose={handleClose}>
      <ModalContainer>
        <CloseDiv>
          <IconButton onClick={handleClose}>
            <CloseIcon />
          </IconButton>
        </CloseDiv>

        {!isLoaded && (
          <LoaderWrapper>
            <CircularProgress /> {/* Show loader until iframe is ready */}
          </LoaderWrapper>
        )}

        {/* <IframeWrapper>
          <iframe
            src={iframeSrc}
            width="100%"
            height="100%"
            style={{ border: 'none' }} // Optional: removes iframe border
            title="Request Access Form"
            allowFullScreen
          ></iframe>
        </IframeWrapper> */}
        <IframeWrapper isLoaded={isLoaded}>
          <iframe
            src={'https://link.iyuga.net/widget/form/mRwqwIryVYc9nKbM3Rxr'}
            style={{
              width: '100%',
              height: '770px',
              border: 'none',
              borderRadius: '20px',
              marginBottom: '50px',
              alignSelf: 'center',
            }}
            id="inline-7UqAPUhwMUZufxa6NKdf"
            // data-layout="{'id':'INLINE'}"
            data-trigger-type="alwaysShow"
            data-trigger-value=""
            data-activation-type="alwaysActivated"
            data-activation-value=""
            data-deactivation-type="neverDeactivate"
            data-deactivation-value=""
            data-form-name="Bug Feedback Form"
            data-layout-iframe-id="inline-7UqAPUhwMUZufxa6NKdf"
            data-form-id="7UqAPUhwMUZufxa6NKdf"
            title="Bug Feedback Form"
            onLoad={() => setIsLoaded(true)} // Mark as loaded when iframe finishes loading
            onLoadStart={() => setIsLoaded(false)}
          ></iframe>
        </IframeWrapper>
      </ModalContainer>
    </StyledModal>
  );
};

export default SignUpPopup;
